import { render, staticRenderFns } from "./ConcreteWidget.vue?vue&type=template&id=f48cf512&"
import script from "./ConcreteWidget.vue?vue&type=script&lang=js&"
export * from "./ConcreteWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports